import React, { Component } from 'react';
import { connect } from 'react-redux';

import { I18n } from 'common/i18n';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { APPROVALS } from 'common/core/approvals_enums';
import { ForgeCheckbox } from '@tylertech/forge-react';

interface AwaitingApprovalFilterProps {
  awaitingApproval: boolean;
  toggleAwaitingApproval: (value: boolean) => void;
}

export class AwaitingApprovalFilter extends Component<AwaitingApprovalFilterProps> {
  render() {
    const { awaitingApproval, toggleAwaitingApproval } = this.props;

    return (
      <div className="filter-section awaiting-approval">
        <div className="checkbox checkbox-filter">
          <ForgeCheckbox
            id="filter-awaiting-approval"
            onChange={toggleAwaitingApproval}
            checked={awaitingApproval}
          >
            {I18n.t('shared.asset_browser.filters.awaiting_approval')}
          </ForgeCheckbox>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  awaitingApproval: state.filters.approvalStatus === APPROVALS.STATUS.PENDING,
});

const mapDispatchToProps = (dispatch: any) => ({
  toggleAwaitingApproval: () => dispatch(filters.toggleAwaitingApproval()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwaitingApprovalFilter);
